import { State, Action, StateContext } from '@ngxs/store';
import { Router, NavigationExtras } from '@angular/router';
import { NgZone } from '@angular/core';

export interface RoutingModel {
  commands: Array<any>;
  extras?: NavigationExtras;
  pageName?: string;
}
export interface RouteLinkModel {
  title: string;
  route: string;
  icon: string;
}
const defaults: RoutingModel = {
  commands: [],
  extras: null,
  pageName: ''
}
export class Navigate {
  static readonly type = '[ROUTER] NAVIGATE';
  constructor(public payload: RoutingModel) { }
}

@State<RoutingModel>({
  name: 'router',
  defaults
})
export class RouterState {
  constructor(private router: Router, public zone: NgZone) { }

  @Action(Navigate)
  changeRoute({ setState }: StateContext<string>, action: Navigate) {
    const path = action.payload;
    this.zone.run(() => { this.router.navigate(path.commands, path.extras); });
    setState(path.commands.toString());
  }
}
